import React, { Component } from "react";
import LCanvas from "./components/LCanvas";
import "./App.css";
import LSystem from "./lib/LSystem";

class App extends Component {
  state = {
    system: LSystem.Sierpinski(10),
    depth: 10,
    name: "Sierpinski"
  };
  render() {
    const { system, name, depth } = this.state;
    return (
      <div>
        <div className="settings">
          <select
            onChange={e => {
              const name = e.target.value;
              this.setState({ name, system: LSystem[name](depth) });
            }}
          >
            {[
              "Fern",
              "Koch",
              "Sierpinski",
              "Tree",
              "Hilbert",
              "Dragon",
              "Binary"
            ].map(n => (
              <option key={n} selected={n == name}>
                {n}
              </option>
            ))}
          </select>
          <input
            type="range"
            onChange={e => {
              const depth = +e.target.value;
              this.setState({
                system: LSystem[name](depth),
                depth
              });
            }}
            value={depth}
            min="1"
            max="14"
          />
          <span>{depth}</span>
        </div>
        <LCanvas lSystem={system} />
      </div>
    );
  }
}

export default App;
